import { gql } from '@apollo/client'

import { INGREDIENT_KEYWORD_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const TRANSFER_INGREDIENT_KEYWORDS_TO_DICTIONARY_TYPE_MUTATION = gql`
  mutation transferIngredientKeywordsToDictionaryType(
    $id: ID!
    $keywordIdsToTransfer: [ID!]
    $type: DictionaryWordType!
  ) {
    transferIngredientKeywordsToDictionaryType(
      id: $id
      keywordIdsToTransfer: $keywordIdsToTransfer
      type: $type
    ) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      uncategorized {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      synonyms {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      varieties {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      discarded {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
    }
  }
  ${INGREDIENT_KEYWORD_NODE_FRAGMENT}
`

export default TRANSFER_INGREDIENT_KEYWORDS_TO_DICTIONARY_TYPE_MUTATION
